var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerpoint2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.34 5.80078V12.9583C54.84 13.0058 64.7325 12.8708 73.225 12.9983C74.83 12.9983 74.9 14.4183 74.92 15.6583C75.055 30.5133 74.8875 45.7958 75 60.6583C74.97 61.2433 74.985 63.4083 74.9675 64.0233C74.9125 66.0808 73.8825 66.1708 71.825 66.2333C71.495 66.2333 70.525 66.2483 70.205 66.2633C62.2525 66.2233 54.3 66.2408 46.34 66.2408V74.1958L5 67.8333V12.1808L46.34 5.80078Z",
    fill: "#D33922"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3434 15.3438H72.5934V63.8438H46.3434V57.4987H65.4284V54.3112H46.3434V50.3363H65.4284V47.1562H46.3509C46.3509 45.5963 46.3509 44.0387 46.3359 42.4812C47.8974 43.0446 49.5648 43.2527 51.2168 43.0905C52.8688 42.9284 54.4638 42.4 55.8859 41.5437C57.3354 40.5913 58.5362 39.3061 59.3881 37.7953C60.2401 36.2845 60.7185 34.592 60.7834 32.8587C57.2834 32.8337 53.8009 32.8437 50.3184 32.8437C50.3184 29.3837 50.3584 25.9262 50.2459 22.4737C48.9409 22.7237 47.6384 22.9987 46.3409 23.2762V15.3462",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9138 20.8086C54.6255 20.9785 57.1828 22.1293 59.1085 24.0462C61.0341 25.9631 62.1965 28.5151 62.3787 31.2261C58.8787 31.2661 55.3963 31.2511 51.9062 31.2511V20.8086",
    fill: "#D33922"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7536 26.8145C22.0711 27.022 27.3036 25.1045 30.8836 28.342C34.3111 32.502 33.4036 40.152 28.3236 42.6395C26.4765 43.3709 24.4741 43.6221 22.5036 43.3695C22.5036 46.4795 22.4886 49.5895 22.5036 52.697C20.9286 52.562 19.3461 52.427 17.7711 52.2995C17.6986 43.7995 17.6836 35.2995 17.7711 26.7995",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4829 31.1135C24.0504 31.041 25.9829 30.756 27.0479 32.226C27.4737 33.0264 27.7049 33.916 27.7227 34.8225C27.7405 35.729 27.5445 36.6269 27.1504 37.4435C26.2429 39.081 24.1929 38.9235 22.6104 39.1135C22.4429 36.4485 22.4604 33.786 22.4829 31.1135Z",
    fill: "#D33922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint2);
export default __webpack_public_path__ + "static/media/powerpoint2.eba172261e5efde69f5fcf91f120df8e.svg";
export { ForwardRef as ReactComponent };